import { palette } from './palette'
import { palette as borderPalette } from './borderPalette'

export const opacities = {
  '0': 0,
  '2': 0.02,
  '3': 0.03,
  '4': 0.04,
  '8': 0.08,
  '12': 0.12,
  '16': 0.16,
  '20': 0.2,
  '24': 0.24,
  '32': 0.32,
  '40': 0.4,
  '48': 0.48,
  '64': 0.64,
  '80': 0.8,
  '96': 0.96,
  '100': 1,
}

const shadows = {
  ...borderPalette,
  'list-item': 'inset 0px -1px 0px rgba(41, 52, 61, 0.04)',
  'list-item-selected': 'inset 0px -1px 0px rgba(41, 52, 61, 0.16)',
  'list-unselected': 'inset 0px -1px 0px rgba(41, 52, 61, 0.04)',
  'page-divider-section': 'inset 0px -4px 0px rgba(41, 52, 61, 0.04)',
}

export const settings = {
  opacities,
  colors: {
    ...palette,
    // aliases used in design:
    // disabled box — neutral-muted-1300
    // disabled text — neutral-muted-2200
    none: 'transparent',
    white: '#FFF',
    black: '#000',
    'page-tint': '#f9fbfc',
    'list-item-unselected':
      'linear-gradient(0deg, rgba(207, 218, 226, 0.16), rgba(207, 218, 226, 0.16)), #FFFFFF',
    'list-item-selected': '#FFF',
    'action-minor': 'rgba(41, 52, 61, 0.8)',
    error: '#E96563',
    'background-tint':
      'linear-gradient(0deg, rgba(207, 218, 226, 0.12), rgba(207, 218, 226, 0.12)), #FFFFFF',
    disabled: 'rgba(41, 52, 61, 0.12)',
    'body-secondary': 'rgba(41, 52, 61, 0.64)',
    'detail-primary': 'rgba(41, 52, 61, 0.64)',
  },
  shadows,
}

export type ThemeColors = keyof typeof settings.colors
export type ThemeShadows = keyof typeof shadows | 'none'

export type ColorsProps = {
  bg?: ThemeColors[] | ThemeColors
  bgClip?: 'content-box' | 'border-box' | 'initial' | 'padding-box' | 'unset'
  boxShadow?: ThemeShadows[] | ThemeShadows
  color?: ThemeColors[] | ThemeColors
  opacity?: keyof typeof opacities
}

export type ColorTheme = typeof settings
